export default {
  meta: {
    title: '选址地图',
  }
};
